import PropTypes from "prop-types";
import React from "react";

import styles from "./OptionBtn.module.scss";

const OptionBtn = ({
  chartType,
  onClick,
  disabled,
  option,
  selected,
  cls = "",
}) => {
  const label = option && option.label;

  return (
    <button
      className={`${
        !disabled && selected
          ? styles["options-container-" + chartType + "-selected"]
          : styles["options-container-" + chartType]
      } ${cls}`}
      onClick={(value) => onClick(value)}
      id={`${chartType}-${label}-label`}
      disabled={disabled}
    >
      {label}
    </button>
  );
};

OptionBtn.propTypes = {
  chartType: PropTypes.string,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  option: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }),
  selected: PropTypes.bool,
};

export default OptionBtn;
